import { useEffect, useRef, useState } from 'react';

export const useScrollAnimation = (options = {}) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Destructure options dengan default value agar dependensi useEffect lebih stabil
  const { 
    threshold = 0.15, 
    rootMargin = '0px 0px -60px 0px', 
    triggerOnce = false // Tambahkan opsi ini jika suatu saat butuh animasi sekali jalan
  } = options;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Set nilai sesuai kondisi: true jika masuk layar, false jika keluar layar
        setIsVisible(entry.isIntersecting);

        // Jika user sengaja ingin animasinya cuma sekali seumur hidup komponen
        if (entry.isIntersecting && triggerOnce) {
          observer.unobserve(entry.target);
        }
      },
      { threshold, rootMargin }
    );

    const el = ref.current;
    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, [threshold, rootMargin, triggerOnce]); // Dependensi yang akurat

  return { ref, isVisible };
};